const sdk = {};

function magic (name, options) {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const params = JSON.stringify(options);

  if (isiOS) {
    return window.webkit.messageHandlers[name].postMessage(params);
  }
  if (isAndroid) {
    return window.hsbApp[name](params);
  }
}

sdk.hsbAppLogin = (options) => {
  return magic('hsbAppLogin', options);
};

sdk.hsbAppShare = (options) => {
  return magic('hsbAppShare', options);
};

sdk.hsbAppShareAction = (options) => {
  return magic('hsbAppShareAction', options);
};

sdk.hideTitle = (options) => {
  return magic('hideTitle', options);
};

sdk.needIntercept = (options) => {
  return magic('needIntercept', options);
};

export const hsbApp = sdk;

export const isInHsbApp = () => {
  const u = navigator.userAgent;
  return u.indexOf('defineInhsbApp') !== -1;
};



// WEBPACK FOOTER //
// ./src/projects/hsbh5/utils/hsbApp.js